import { render, staticRenderFns } from "./RequiredField.vue?vue&type=template&id=2fa64945"
import script from "./RequiredField.vue?vue&type=script&lang=js"
export * from "./RequiredField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports